export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ../~/rmc-feedback/es/index.js
// module id = 2147
// module chunks = 1